if (!customElements.get('mili-help-page')) {
 customElements.define('mili-help-page',class extends HTMLElement {
  connectedCallback() {
   this.timer = setTimeout(() => this.init(),0);
  }
  init() {
   this.controller?.abort();
   this.controller = new AbortController();
   const options = {signal:this.controller.signal};
   const links = [...this.querySelectorAll('[data-mili-help-link]')];
   const aliases = new Map();
   this.querySelectorAll('details[data-mili-anchor]').forEach((details,index) => {
    const oldId = details.id;
    const base = details.dataset.miliAnchor || `topic-${index+1}`;
    let slug = base, suffix = 2;
    while(document.getElementById(slug) && document.getElementById(slug) !== details) slug = `${base}-${suffix++}`;
    details.id = slug;
    aliases.set(oldId,slug);
    links.filter(link => link.hash === `#${oldId}`).forEach(link => link.setAttribute('href',`#${slug}`));
   });
   const openHash = () => {
    let hash;
    try { hash = decodeURIComponent(location.hash.slice(1)); } catch { return; }
    const slug = aliases.get(hash) || hash;
    const details = document.getElementById(slug);
    if(!details || !this.contains(details) || details.tagName !== 'DETAILS') return;
    details.open = true;
    if(aliases.has(hash)) history.replaceState(history.state,'',`${location.pathname}${location.search}#${slug}`);
    details.scrollIntoView({block:'start',behavior:'auto'});
   };
   this.addEventListener('click',event => {
    const link = event.target.closest('[data-mili-help-link]');
    if(!link || !this.contains(link)) return;
    const details = document.getElementById(link.hash.slice(1));
    if(details && this.contains(details)) details.open = true;
   },options);
   window.addEventListener('hashchange',openHash,options);
   this.addEventListener('shopify:block:select',event => {
    const details = event.target.closest('details');
    if(details && this.contains(details)) details.open = true;
   },options);
   openHash();
  }
  disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); }
 });
}
